/** Resolve populated organization references and legacy name_id route values. */
export function normalizeOrganizationId(value: any, depth = 0): string {
  if (value == null || depth > 5) return '';
  if (typeof value === 'object') {
    for (const key of ['_id', 'orgId', 'id', 'organization', '$oid']) {
      const id = normalizeOrganizationId(value[key], depth + 1);
      if (id) return id;
    }
    return '';
  }
  if (typeof value !== 'string') return '';
  let id = value.trim();
  try { id = decodeURIComponent(id); } catch (_) { return ''; }
  if (id.includes('_')) id = id.split('_').pop();
  if (!id || /\[object\s+Object\]/i.test(id) || /^(null|undefined)$/i.test(id)) return '';
  return id;
}
